import React from 'react';
import { Navigate } from 'react-router-dom';
import { getScreenPermission } from '../../utils/permissions';

const ALWAYS_ALLOWED = [
  "/logout",
  "/notification",
  "/setting",
  '/user'
];



const ProtectedRoute = ({ path, children, redirectTo = '/home' }) => {
  const permissions = getScreenPermission();
  const basePath = path.split("/:")[0];

  const isAllowed =
    ALWAYS_ALLOWED.includes(path) ||
     (permissions?.[path] ?? permissions?.[basePath]) === true;

  return (
    <React.Fragment>
      {isAllowed ? (
        children
      ) : (
        <Navigate to={redirectTo} replace />
      )}
    </React.Fragment>
  );
};

export default ProtectedRoute;
